<template>
	<b-modal
		id="setprimary"
		size="md"
		centered
		hide-footer
		hide-header
		v-model="showModal"
		@hidden="$emit('close-modal')"
	>
		<div class="d-flex">
			<div class="w-100">
				<div
					class="candash-modal-top no-border-bottom align-items-center profiles-flex-column p-3"
				>
					<div class="pro-width-10">
						<img
							class="mr-3"
							src="@/assets/newdesign/dashboard/greenModal.svg"
							alt=""
						/>
					</div>
					<div class="pro-pl-3">
						<div class="d-flex align-items-start justify-content-between">
							<div class="mb-header-txt pr-4 pro-text-center">
								Do you want to set "{{ localCandidateInfo.profileName }}" as
								your Primary Profile
							</div>
							<div
								id="hideinmobile"
								class="d-flex justify-content-end pointer pt-2"
								@click="$emit('close-modal')"
							>
								<img
									class="rotate-on-hover"
									src="@/assets/newdesign/dashboard/blueCross.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
				</div>

				<div
					class="p-3 no-border-top d-flex align-items-center justify-content-end gap-4"
				>
					<b-button
						class="candash-cancelBtn pro-w-50"
						@click="$emit('close-modal')"
						>Cancel</b-button
					>
					<div class="position-relative pro-w-50">
						<b-button
							class="candash-addBtn pro-w-100"
							@click="isSettingPrimary ? null : handleRadioChange()"
							:class="
								isSettingPrimary
									? 'loader-class-setprim defaultCursor'
									: 'pointer'
							"
							>{{ isSettingPrimary ? "" : "Set as Primary" }}
						</b-button>
						<div v-if="isSettingPrimary" class="loader-pos-new">
							<Loader />
						</div>
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import {
	setPrimaryProfile,
	getAllProfiles,
	getCandidatePrimaryProfile,
	getProfileCompletion,
} from "@/utils/apiFunctions";
import { getCandidateDetail } from "@/controllers/dashboard/asynchronous.js";
import Loader from "@/components/fixedcomponents/Loader.vue";
export default {
	name: "SetPrimary",
	data() {
		return {
			isSettingPrimary: false,
			allProfiles: [],
		};
	},
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
		localCandidateInfo: {
			type: Object,
			default: () => {},
		},
	},
	components: {
		Loader,
	},
	methods: {
		async handleRadioChange() {
			this.isSettingPrimary = true;
			if (!this.localCandidateInfo.primary) {
				let payload = { id: this.localCandidateInfo._id };
				const response = await setPrimaryProfile(payload);
				if (response.status === 200) {
					// await this.getCandidateDetailTabs();
					this.getAllProfiles();

					const res = await getCandidatePrimaryProfile();
					if (res.status === 200) {
						this.$store.commit(
							"candidateVUEX/setPrimaryProfile",
							res.data.data
						);

						this.localCandidateInfo = await getCandidateDetail(this);
						this.$store.commit(
							"candidateVUEX/setCandidateInfo",
							this.localCandidateInfo
						);
					}

					const respData = await getProfileCompletion(
						this.localCandidateInfo._id
					);
					const candProgressPrimaryResp = respData.data.data;
					this.$store.commit(
						"candidateVUEX/updateCandidateProgressPrimary",
						candProgressPrimaryResp
					);

					this.$emit("close-modal");
					this.$emit("update-isPrimary");
				}
			}
			this.isSettingPrimary = false;
		},
		async getAllProfiles() {
			this.allProfiles = (await getAllProfiles()).data.data.map((profile) => {
				return {
					profileName: profile.profileName,
					_id: profile._id,
					primary: profile.primary,
				};
			});
		},
	},
};
</script>
